var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInstagram = function SvgInstagram(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0003 35.7584C45.0003 40.8613 40.8611 45.0004 35.7571 45.0004H9.24321C4.1382 45.0004 0 40.8613 0 35.7584V9.24603C0 4.14112 4.1382 0 9.24321 0H35.7571C40.8611 0 45.0003 4.14112 45.0003 9.24603V35.7584Z",
    fill: "url(#paint0_linear_20264_101829)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8928 27.7456C34.8928 31.6817 31.6991 34.87 27.7629 34.87H18.8796C14.9409 34.87 11.748 31.6817 11.748 27.7456V18.8702C11.748 14.9375 14.9409 11.7458 18.8796 11.7458H27.7629C31.6991 11.7458 34.8928 14.9375 34.8928 18.8702V27.7456ZM28.8178 9H17.825C12.9506 9 9 12.9479 9 17.8181V28.8002C9 33.6687 12.9506 37.6157 17.825 37.6157H28.8178C33.6914 37.6157 37.642 33.6687 37.642 28.8002V17.8181C37.642 12.9479 33.6914 9 28.8178 9V9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7088 27.8926C21.2003 27.8926 19.1685 25.8617 19.1685 23.3579C19.1685 20.8516 21.2003 18.8233 23.7088 18.8233C26.2148 18.8233 28.2475 20.8516 28.2475 23.3579C28.2475 25.8617 26.2148 27.8926 23.7088 27.8926M23.7091 15.8213C19.5417 15.8213 16.1641 19.1942 16.1641 23.358C16.1641 27.5191 19.5417 30.8955 23.7091 30.8955C27.8757 30.8955 31.2533 27.5191 31.2533 23.358C31.2533 19.1942 27.8757 15.8213 23.7091 15.8213",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2422 15.5633C32.2422 16.5989 31.401 17.4375 30.3668 17.4375C29.3309 17.4375 28.4922 16.5989 28.4922 15.5633C28.4922 14.5285 29.3309 13.6875 30.3668 13.6875C31.401 13.6875 32.2422 14.5285 32.2422 15.5633",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20264_101829",
    x1: 22.7307,
    y1: -13.7197,
    x2: -13.5553,
    y2: 23.8308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6968DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385505,
    stopColor: "#D22A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD879"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInstagram);
export default ForwardRef;